/**
 * ApexCharts rejeita Promises com Error('Element not found') quando o alvo DOM
 * some (navegação, v-if). É a única origem dessa mensagem no bundle do admin.
 */

export function apexChartsElementNotFoundMessage(reason) {
    if (reason == null) return '';
    if (typeof reason === 'string') return reason;
    if (typeof reason === 'object' && typeof reason.message === 'string') {
        return reason.message;
    }
    return String(reason);
}

export function isApexChartsElementNotFoundReason(reason) {
    return apexChartsElementNotFoundMessage(reason).includes('Element not found');
}

/**
 * Evita que rejeições benignas cheguem ao handler global do Sentry.
 * Deve ser registado antes de Sentry.init.
 */
export function installApexChartsUnhandledRejectionGuard() {
    if (typeof window === 'undefined') return;

    window.addEventListener(
        'unhandledrejection',
        (event) => {
            if (isApexChartsElementNotFoundReason(event.reason)) {
                event.preventDefault();
            }
        },
        true
    );
}

/** Aguarda paint estável antes de montar gráficos (mitiga race no mobile). */
export function waitForChartDomReady() {
    return new Promise((resolve) => {
        requestAnimationFrame(() => requestAnimationFrame(resolve));
    });
}
